const EnglishHairstudio = {
  beranda: 'Home',
  visiMisi: 'Mission',
  // cerita: 'Story',
  tentangKami: 'About Us',
  lokasi: 'Location',
  kontak: 'Contact',
  karir: 'Careers',
  lainnya: 'Other',
}

export default EnglishHairstudio;